// extracted by mini-css-extract-plugin
module.exports = {"amount":"BalanceDue_amount__15QqL","list":"BalanceDue_list__Wd8SP","listRow":"BalanceDue_listRow__3XF2R","total":"BalanceDue_total__kCwmc"};